export const LoadingBar = () => {
  return (
    <div className="min-h-screen pb-24 bg-background flex items-center justify-center">
      <div className="w-64 space-y-3">
        <div className="relative h-2 bg-muted rounded-full overflow-hidden">
          <div className="absolute inset-0 bg-gradient-dwellie animate-pulse" />
          <div 
            className="absolute inset-0 animate-[shimmer_2s_ease-in-out_infinite]"
            style={{
              background: 'linear-gradient(90deg, transparent, hsl(var(--background) / 0.6), transparent)',
              backgroundSize: '200% 100%',
            }}
          />
        </div>
        <p className="text-center text-sm text-muted-foreground">Loading...</p>
      </div>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};